<template>
  <header>
    <div class="container">
      <div class="row">
        <div class="col-12 col-md-auto">
          <a :href="url" class="logo">
            <img
              :src="require('@/assets/static/images/auth_logo.svg')"
              alt=""
            />
            <span>{{ $t("app.beta") }}</span>
          </a>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  computed: {
    url() {
      return process.env.VUE_APP_LANDING_PAGE;
    },
  },
};
</script>
